export default "__VITE_ASSET__ce7ba505__"